import React, { Component } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Chatbox.css';
import {
  withApiContext,
  withUserContext
} from "context";

class ChatBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: props.comments,
      isLoading: true,
      newMessage: '',
      showAllComments: false, // State to toggle between limited and all comments
    };
  }

  componentDidMount() {
    const { comments } = this.props;
    if (comments.length > 0) {
      this.setState({ messages: comments, isLoading: false });
    }
    this.handleChatIconClick();
  }

  handleChatIconClick = async () => {
    console.log("handleChatIconClick triggered");
    this.setState(prevState => ({ showChat: !prevState.showChat }));

    try {
      const response = await this.props.ctx_api.privateRequest({
        cmd: "api/comments",
        args: {
          topicId: this.props.topicId || null
        },
      });
      this.setState({ messages: response.rsp , isLoading:false});
    } catch (error) {
      console.error('API call failed:', error);
    }
  };

  handlePostMessage = async () => {
    const { newMessage } = this.state;
    if (newMessage.trim()) {
      try {
        const response = await this.props.ctx_api.privateRequest({
          cmd: "api/postComment",
          args: {
            memberId:this.props.ctx_user.user.id,
            topicId: this.props.topicId,
            message: newMessage,
            studentName : this.props.ctx_user.user.firstName + " " + this.props.ctx_user.user.lastName
          }
        });
        if (response && response.rsp) {
          console.log(response)
          this.handleChatIconClick()
        }
      } catch (error) {
        console.error('Failed to post message:', error);
      }
    }
    this.setState({ newMessage: '' });
  };

  handleClose = () => {
    this.props.onClose();
  };

  handleInputChange = (e) => {
    this.setState({ newMessage: e.target.value });
  };

  handleTopicClick = async ( ) => { 
    this.props.ctx_api
      .privateRequest({
        cmd: "discourse/sso",
      })
      .then(({ rsp }) => {
        console.log(rsp)
        window.open(rsp);
      })
  };

  // Toggle showing all comments or the latest three
  loadMoreMessages = () => {
    this.setState(prevState => ({
      showAllComments: !prevState.showAllComments
    }));
  };

  render() {
    const { messages, isLoading, newMessage, showAllComments } = this.state;

    // Determine how many messages to display
    const displayedMessages = showAllComments ? messages : messages.slice(-3); // Show last 3 messages

    return (
      <div>
        {/* <div className="chat-header">
          <span>Chat</span>
          <FontAwesomeIcon icon={faTimes} className="close-icon" onClick={this.handleClose} />
        </div> */}
        <div className={`messages ${showAllComments ? 'show-all' : ''}`}>
          {isLoading ? (
            <div className="loading-message">Loading messages...</div>
          ) : (
            displayedMessages.map((messageObj, index) => (
              <div
                key={index}
                className={`message ${messageObj.username === 'You' ? 'sent' : 'received'} ${index === 0 ? 'topic' : ''}`}
              >
                {/* <strong>{messageObj.username}</strong> */}
                <p>{messageObj.replies}</p>
              </div>
            ))
          )}
        </div>
        {!isLoading &&<div className="comments-container">
          {/* <span className="comments-left"> */}
          <button onClick={this.loadMoreMessages} className="comments-left">
            {showAllComments ? "Show Less" : "All Comments"} <span>&#8595;</span>
            </button>
        <button onClick={this.handleTopicClick} className="comments-right">
          Show in discourse
        </button>
        </div>}

    {/* {!isLoading && (
      <button onClick={this.loadMoreMessages} className="load-more-button">
        {showAllComments ? "Show Less" : "All Comments"} <span>&#8595;</span>
      </button>
    )} */}

        {/* {!isLoading && <button onClick={this.loadMoreMessages} className="load-more-button">
          {showAllComments ? "Show Less" : "All Comments"} <span>&#8595;</span>
        </button>} */}
        <div className="new-message-container">
          <input
            type="text"
            value={newMessage}
            onChange={this.handleInputChange}
            className="new-message-input"
            placeholder="Type your reply..."
          />
          <button onClick={this.handlePostMessage} className="post-button">Post</button>
        </div>
      </div>
    );
  }
}

export default withApiContext(withUserContext(ChatBox));
